import { useNavigate, NavLink } from 'react-router-dom';
import { Layout, message, Row, Col, Card, Form, Input, Button, Space } from 'antd';
import { MailTwoTone, LockTwoTone, GoogleOutlined, FacebookFilled } from '@ant-design/icons';
import gibobsLogo from '../../assets/banks/sabadell-white.svg';
import { login } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';

const { Content } = Layout;

const LoginPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const onFinish = async (values) => {
		dispatch(login({ username: values.username, password: values.password, navigate }));
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};

	return (
		<Layout
			style={{
				width: isMobileOnly ? 400 : undefined,
				marginTop: isMobileOnly ? '20%' : undefined
			}}>
			<Content style={{ marginTop: '10%', marginLeft: '-4%' }}>
				<Row justify="space-around" align="middle" style={{ height: '100%' }}>
					<Col lg={6} md={12} xs={24} sm={24}>
						<Card
							cover={
								<div style={{ textAlign: 'center', backgroundColor: '#212121' }}>
									<img
										src={gibobsLogo}
										style={{ textAlign: 'center', height: '100px', width: '90%' }}
										alt="Gibobs all banks"></img>
								</div>
							}>
							<Form name="login" onFinish={onFinish} onFinishFailed={onFinishFailed}>
								<Form.Item
									name="username"
									rules={[{ required: true, message: 'Introduzca su email' }]}>
									<Input
										type="email"
										prefix={<MailTwoTone className="site-form-item-icon" />}
										placeholder="Usuario"
										aria-label="Correo electrónico"
									/>
								</Form.Item>
								<Form.Item
									name="password"
									rules={[
										{
											required: true,
											message: 'Por favor, introduzca su contraseña'
										}
									]}>
									<Input.Password
										prefix={<LockTwoTone className="site-form-item-icon" />}
										placeholder="Contraseña"
										aria-label="Contraseña"
									/>
								</Form.Item>
								<Form.Item>
									<Button type="primary" htmlType="submit" block>
										Acceder
									</Button>
								</Form.Item>
								<Form.Item style={{ textAlign: 'center' }}>
									<Space>
										<Button
											style={{ background: '#ee3314', border: 'none' }}
											block
											type="primary"
											icon={<GoogleOutlined />}
											href={`https://dev.api.gibobs.net/auth/google?target=app_login&managementCode=${process.env.REACT_APP_BRAND_MANAGEMENT}`}>
											Google
										</Button>
										<Button
											style={{ background: '#1877f2', border: 'none' }}
											type="primary"
											icon={<FacebookFilled />}
											block
											href={`https://dev.api.gibobs.net/auth/facebook?target=app_login&managementCode=${process.env.REACT_APP_BRAND_MANAGEMENT}`}>
											Facebook
										</Button>
									</Space>
								</Form.Item>
								<Form.Item style={{ textAlign: 'center' }}>
									<Space>
										<NavLink to="/auth/forgot-password">¿Olvidaste tu contraseña?</NavLink>
										<NavLink to="/register">Registrarse</NavLink>
									</Space>
								</Form.Item>
							</Form>
						</Card>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default LoginPage;
